import { Grid, Stack } from "@mui/material";
import FormFields from "components/UI/FormFields/FormFields";
import { InputTypes } from "constants/enums";
import dayjs from "dayjs";
import { IFormField } from "models/app";
import { forwardRef, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
  onChangeFrom: (date: Date | string) => void;
  onChangeTo: (date: Date | string) => void;
  valueFrom: any;
  valueTo: any;
}

const FiltersDate = forwardRef<any, Props>(
  ({ onChangeFrom, onChangeTo, valueFrom, valueTo }, ref) => {
    const {
      control,
      watch,
      setValue,
      reset,
      register,
      formState: { errors },
    } = useForm<any>({ mode: "onChange" });

    const { t, i18n } = useTranslation();

    let filterFields: IFormField[] = [
      {
        name: "Start_Date",
        label: t("T_start_date"),
        type: InputTypes.CALENDER,
        defaultValue: valueFrom,
        onChange: (value: string) => {
          onChangeFrom(value);
        },
        hideLabel: true,
        grid: 12
      },
      {
        name: "End_Date",
        label: t("T_end_date"),
        type: InputTypes.CALENDER,
        defaultValue: valueTo,
        onChange: (value: string) => {
          onChangeTo(value);
        },
        hideLabel: true,
        grid: 12
      },
    ];

    useImperativeHandle(ref, () => {
      return {
        resetFilters: () => {
          setValue("Start_Date", null);
          setValue("End_Date", null);
          reset();
        },
      };
    });

    return (
      <>
        {filterFields.map((field: any, index: number) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <FormFields
              {...field}
              control={control}
              errors={errors}
              watch={watch}
              reset={reset}
              setValue={setValue}
              register={register}
            />
          </Grid>
        ))}
      </>
    );
  }
);
export default FiltersDate;
